import { render, staticRenderFns } from "./CreateUblArchiveModalProgress.vue?vue&type=template&id=866cb25a&scoped=true"
import script from "./CreateUblArchiveModalProgress.vue?vue&type=script&lang=ts"
export * from "./CreateUblArchiveModalProgress.vue?vue&type=script&lang=ts"
import style0 from "./CreateUblArchiveModalProgress.vue?vue&type=style&index=0&id=866cb25a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "866cb25a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('866cb25a')) {
      api.createRecord('866cb25a', component.options)
    } else {
      api.reload('866cb25a', component.options)
    }
    module.hot.accept("./CreateUblArchiveModalProgress.vue?vue&type=template&id=866cb25a&scoped=true", function () {
      api.rerender('866cb25a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-default/CreateUblArchiveModalProgress.vue"
export default component.exports